import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  constructor(private http: HttpClient) {}
  Controller = 'Package'

  getPackages(body: any) {
    return this.http.post(`${this.Controller}/SearchPackages`, body)
  }
  getArchivePackages(body: any) {
    return this.http.post(`${this.Controller}/Archive`, body)
  }

  addPackage(body: any) {
    return this.http.post(`${this.Controller}/CreatePackage`, body)
  }

  updatePackage(body: any) {
    return this.http.put(`${this.Controller}/UpdatePackage`, body)
  }
  addVersion(body: any) {
    return this.http.post(`${this.Controller}/AddVersion`, body)
  }

  deletePackage(id: any) {
    return this.http.delete(`${this.Controller}/Delete/${id}`)
  }
  undoPackage(id: any) {
    return this.http.post(`${this.Controller}/Undo/${id}`, {})
  }

  getPackageById(id: any) {
    return this.http.get(`${this.Controller}/GetPackage/${id}`)
  }
  getPackageVersions(id: any) {
    return this.http.get(`${this.Controller}/GetVersions/${id}`)
  }
  getVersionById(id: any) {
    return this.http.get(`${this.Controller}/GetVersion/${id}`)
  }

  exportAllPackage(params: any) {
    return this.http.get(`${this.Controller}/Export`, {
      params,
      responseType: 'arraybuffer'
    })
  }

  updateReassesmentFrequency(data: any) {
    return this.http.post(`${this.Controller}/AssessmentFrequency`, data)
  }

  approvePackage(id: any) {
    return this.http.post(`${this.Controller}/Approve/${id}`, {})
  }
  requestAssessment(data: any) {
    return this.http.post(`${this.Controller}/RequestAssessment`, data)
  }
  getFrequencyByPackageId(id: any) {
    return this.http.get(`${this.Controller}/AssessmentFrequency/${id}`)
  }

  getControlsById(id: any, searchVal: any) {
    return this.http.get(
      `${this.Controller}/ControlDetails/${id}?search=${searchVal}`
    )
  }

  reassign(body: any) {
    return this.http.post(`${this.Controller}/Reassign`, body)
  }
  reassignControl(body: any) {
    return this.http.post(`${this.Controller}/ReassignControl`, body)
  }
  getPackagesSummary(body: any) {
    return this.http.post(`${this.Controller}/Summary`, body)
  }
  exportSummary(params: any) {
    return this.http.get(`${this.Controller}/ExportSummary`, {
      params,
      responseType: 'arraybuffer'
    })
  }
}
